// extracted by mini-css-extract-plugin
export var backdropBlur = "_cg-0";
export var contentCard = "_cg-5";
export var frame = "_cg-2";
export var image = "_cg-4";
export var imagePane = "_cg-3";
export var modal = "_cg-1";